import axios, {AxiosResponse} from 'axios'
import {ID, Response} from '../../../../_metronic/helpers'
import {State, StateQueryResponse} from './_models'

const API_URL = process.env.REACT_APP_THEME_API_URL
const STATES_URL = `${API_URL}/state`
// const GET_COUNTRIES_URL = `${API_URL}/user`

const getStates = (query: string): Promise<StateQueryResponse> => {
  return axios
    .get(`${STATES_URL}?${query}`)
    .then((d: AxiosResponse<StateQueryResponse>) => d.data)
}
const getStateById = (id: ID): Promise<State | undefined> => {
  return axios
    .get(`${STATES_URL}/${id}`)
    .then((response: AxiosResponse<Response<State>>) => response.data)
    .then((response: Response<State>) => response.data)
}

const createState = (model: State): Promise<StateQueryResponse | undefined> => {
  return axios
    .post(STATES_URL, model)
    .then((response: AxiosResponse<StateQueryResponse>) => response.data)
    .then((response: StateQueryResponse) => response)
}

const updateState = (model: State): Promise<StateQueryResponse> => {
  return axios
    .post(`${STATES_URL}/${model.id}`, model)
    .then((response: AxiosResponse<StateQueryResponse>) => response.data)
    .then((response: StateQueryResponse) => response)
}

const deleteState = (modelId: ID): Promise<StateQueryResponse | undefined> => {
  return axios
  .delete(`${STATES_URL}/${modelId}`)
  .then((response: AxiosResponse<StateQueryResponse>) => response.data)
  .then((response: StateQueryResponse) => response)
}

const deleteSelectedStates = (modelIds: Array<ID>): Promise<void> => {
  const requests = modelIds.map((id) => axios.delete(`${STATES_URL}/${id}`))
  return axios.all(requests).then(() => {})
}

export {getStates,getStateById,createState,updateState,deleteState,deleteSelectedStates}
